import { put, call, takeEvery } from 'redux-saga/effects';
import { getUserProfile } from '../../../requests/user_profile_requests/get_user_profile_request';
import { addDivisions, delDivisions } from '../../../requests/userDivisionsRequests';
import { clearUsersCacheRequest } from '../../../../User_create/requests/clear_users_cache';
import { getErrorMessage } from '../../../../../../shared/helpers';
import { message_error } from '../../../../../../components/Message';

function* changeUserDivisions({ payload }) {
    try {
        const { action, userId, divisions } = payload;

        yield put({
            type: 'SET_USER_PROFILE_DATA',
            payload: {
                User_profile_divisions: {
                    loading: true,
                },
            },
        });

        if (action === 'addDivisions') {
            yield call(addDivisions, userId, divisions);
        } else if (action === 'delDivisions') {
            yield call(delDivisions, userId, divisions);
        }

        const { options: profile } = yield call(getUserProfile, userId);

        yield put({
            type: 'SET_USER_PROFILE_DATA',
            payload: {
                User_profile_divisions: {
                    loading: false,
                },
                'User_profile_table.profile.divisions': profile.divisions,
            },
        });

        yield call(clearUsersCacheRequest);
    } catch (error) {
        message_error(getErrorMessage(error));
    } 
}

export default function* changeUserDivisionsSaga() {
    yield takeEvery('CHANGE_USER_PROFILE_DIVISIONS_SAGA', changeUserDivisions);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_profile_divisions_saga/changeUserDivisions.saga.js